import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SessionService } from '../../session-service/session.service';
import { API_URL } from '../../constants/apiurl-constants';

@Injectable({
  providedIn: 'root'
})
export class TopNavigationService {
  private clientManagerNavigation = new BehaviorSubject<boolean>(false);
  clientManagerNavigation$ = this.clientManagerNavigation.asObservable();
  showStudyNav = false;
  showStudyNavRight = true;
  showFeedback = true;
  showInsight = true;
  isClientManager = true;
  isClientUser = false;
  isClientAdmin = false;
  private enableEmployeeProjectDrawer: boolean;
  private enableAgileAnalyzer: boolean;

  constructor(public sessionService: SessionService) { }

  setClientManagerNavigation(isClientManagerNavigation: boolean): void {
    this.clientManagerNavigation.next(isClientManagerNavigation);
  }

  setStudyNav(status: boolean) {
    this.showStudyNav = status;
  }
  setStudyNavRight(status: boolean) {
    this.showStudyNavRight = status;
  }
  getStudyNav() {
    return this.showStudyNav;
  }
  getStudyNavRight() {
    return this.showStudyNavRight;
  }
  setIsClientManager(status: boolean) {
    this.isClientManager = status;
  }
  getIsClientManager() {
    return this.isClientManager;
  }
  setIsClientUser(status: boolean) {
    this.isClientUser = status;
  }
  getIsClientUser() {
    return this.isClientUser;
  }
  
  getIsClientAdmin() {
    return this.isClientAdmin;
  }
  setIsClientAdmin(status: boolean) {
    this.isClientAdmin = status;
  }

  setShowFeedback(status: boolean) {
    this.showFeedback = status;
  }
  getShowFeedback() {
    return this.showFeedback;
  }

  getClientManagerInsightAccess()
  {
    return this.showInsight;
  }

  setClientManagerInsightAccess(status: boolean)
  {
    this.showInsight = status;
  }

  set EnableEmployeeProjectDrawer(val: boolean) {
    this.enableEmployeeProjectDrawer = val;
  }
  get EnableEmployeeProjectDrawer(): boolean {
    return this.enableEmployeeProjectDrawer;
  }  
  set setEnableAgileAnalyzer(val: boolean) {
    this.enableAgileAnalyzer = val;
  }
  get getEnableAgileAnalyzer(): boolean {
    return this.enableAgileAnalyzer;
  }

}
